import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Tab,
  Tabs,
  Stack,
  Container,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// hooks
import useTabs from 'src/hooks/useTabs';
import useSettings from 'src/hooks/useSettings';
import useAuth from 'src/hooks/useAuth';
import useTable, { emptyRows } from 'src/hooks/useTable';

// components
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableEmptyRows, TableHeadCustom, TableNoData, TableSelectedActions } from 'src/components/table';
// sections

import { useDispatch, useSelector } from 'src/redux/store';
//components
import { validaLabelMenuDatas } from 'src/utils/functions';
import v2_actionListaChatsSupervisao from 'src/actions/v2/dashboard/supervisao/v2_actionListaChatsSupervisao';
import moment from 'moment';
import SupervisaoRow from 'src/sections/@dashboard/supervisao/SupervisaoRow';
import SupervisaoChatItem from 'src/sections/@dashboard/supervisao/SupervisaoChatItem';
import ChatWindow from 'src/sections/@chats/chat/ChatWindow';
import { getListaSetoresTransferencia, getListaUsuariosTransferencia } from 'src/redux/slices/user';
import { getMensagensWhatsapp, getMensagensWhatsappDb, setChatInfo, setMessage, setLimparChatInfo } from 'src/redux/slices/chat';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import DrawerChatWhatsapp from 'src/sections/@chats/chat/DrawerChatWhatsapp';
import { RowInput } from 'src/components/forms/RowInput';
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';

//zui
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'src/@/components/ui/select';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { SelectZui } from 'src/components/zui';
// ----------------------------------------------------------------------

import { Button } from 'src/@/components/ui/button';
import MenuDatas2 from 'src/components/MenuDatas2';
import { Input } from 'src/@/components/ui/input';
import { TableHead, Table, TableBody, TableHeader } from 'src/@/components/ui/table';
import { Card } from 'src/@/components/ui/card';
import { cn } from 'src/@/lib/utils';
import { SupervisaoExport } from 'src/sections/@dashboard/supervisao/SupervisaoExport';
import v2_actionGerarExcelRelatorioChats from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioChats';
import SkeletonSupervisionList from 'src/@/components/use/skeleton/SkeletonDashboardPage';
import v2_actionGerarExcelRelatorioChatsPrimeiroContato from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioChatsPrimeiroContato';
import PageContainerHeader from 'src/components/PageContainerHeader';


const TABLE_HEAD = [
  { id: 'statusRoom', label: 'Status' },
  { id: 'numeroCliente', label: 'Numero' },
  { id: 'nome_contato', label: 'Nome do chat' },
  { id: 'nome_usuario', label: 'Atendente' },
  { id: 'nome_setor', label: 'Setor' },
  { id: 'lastUpdate', label: 'Ultima Atividade' },
  { id: 'dataCriacao', label: 'Data Criação' },
  { id: 'chatbot', label: 'Chatbot' },
  { id: 'sentimento', label: 'Sentimento' },
  { id: '' },
];

const STATUS_OPTIONS = [
  { value: null, label: "Todos" },
  { value: 'Atendendo', label: "Atendendo" },
  { value: 'Pendente', label: "Em fila" },
  { value: 'Finalizado', label: "Finalizados" },
  { value: 'Geral', label: "No bot" },
  { value: 'Avaliando', label: "Avaliando" }
];

const STATUS_SIDEBAR_OPTIONS = [
  { value: null, label: "Todos", icon: "mdi:forum-outline", dot: "bg-gray-400", activeBg: "bg-[#7C3AED]/10", activeBorder: "border-[#7C3AED]", activeIcon: "text-[#7C3AED]", activeLabel: "text-[#7C3AED]" },
  { value: 'Atendendo', label: "Atendendo", icon: "mdi:headset", dot: "bg-amber-500", activeBg: "bg-amber-50", activeBorder: "border-amber-500", activeIcon: "text-amber-600", activeLabel: "text-amber-700" },
  { value: 'Pendente', label: "Em fila", icon: "mdi:clock-fast", dot: "bg-red-500", activeBg: "bg-red-50", activeBorder: "border-red-500", activeIcon: "text-red-600", activeLabel: "text-red-700" },
  { value: 'Finalizado', label: "Finalizados", icon: "mdi:check-circle-outline", dot: "bg-emerald-500", activeBg: "bg-emerald-50", activeBorder: "border-emerald-500", activeIcon: "text-emerald-600", activeLabel: "text-emerald-700" },
  { value: 'Geral', label: "No bot", icon: "mdi:robot-happy-outline", dot: "bg-blue-500", activeBg: "bg-blue-50", activeBorder: "border-blue-500", activeIcon: "text-blue-600", activeLabel: "text-blue-700" },
  { value: 'Avaliando', label: "Avaliando", icon: "mdi:star-half-full", dot: "bg-purple-500", activeBg: "bg-purple-50", activeBorder: "border-purple-500", activeIcon: "text-purple-600", activeLabel: "text-purple-700" },
];

// ----------------------------------------------------------------------

export default function SupervisaoLista() {
  const { themeStretch } = useSettings();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    //
    selected,
    setSelected,
    onSelectRow,
    onSelectAllRows,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable({ defaultOrderBy: 'date_created', defaultRowsPerPage: 25 });

  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  const { listaFunil, chatInfo, mensagens } = useSelector((state) => state.chat);
  const { user, cliente } = useAuth();
  const [filterName, setFilterName] = useState('');
  const [filterPesquisa, setFilterPesquisa] = useState('');
  const { currentTab: filterStatus, onChangeTab: onChangeFilterStatus } = useTabs(null);
  const [inicio, setInicio] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [periodo, setPeriodo] = useState('mes_atual')
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuDatas = Boolean(anchorEl);
  const [valorEscolhidoUsuario, setValorEscolhidoUsuario] = useState("");
  const [valorEscolhidoSetor, setValorEscolhidoSetor] = useState("");
  const [valorEscolhidoSentimento, setValorEscolhidoSentimento] = useState("");

  const [chat, setChat] = useState(null);
  const [openChatdetalhes, setOpenChatDetalhes] = useState(false);
  const [loadingListaChats, setLoadingListaChats] = useState(false);
  const [isPesquisado, setIsPesquisado] = useState(false);
  const [listaChatsPesquisa, setListaChatsPesquisa] = useState([]);
  const [listaChatsFiltro, setListaChatsFiltro] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const tableData = isPesquisado ? listaChatsPesquisa : listaChatsFiltro;
  const [loadingVerDetalhes, setLoadingVerDetalhes] = useState(false);


  const [listaClientesCanais, setListaClientesCanais] = useState([]);
  const isMultisession = cliente.multiSession === 1;
  const [listaTags, setListaTags] = useState([]);
  const [clienteIdPadrao, setClienteIdPadrao] = useState(isMultisession ? null : user.clienteId);
  const [valorEscolhidoTag, setValorEscolhidoTag] = useState("");
  const [viewMode, setViewMode] = useState('table'); // 'table' | 'split'
  const [splitVisibleCount, setSplitVisibleCount] = useState(25);



  async function buscarListaClientesCanais() {
    try {
      const response_clientes_canais = await actionListaClientesCanais(cliente._id)
      setListaClientesCanais(response_clientes_canais.data.data);
      if (isMultisession) {
        setClienteIdPadrao(response_clientes_canais.data.data[0].cliente_id);
      }
    } catch (err) {
      console.log(err)
    }
  }

  function obterNumeroPorClienteId(cliente_id, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].cliente_id === cliente_id) {
        return arr[i].nome;
      }
    }
    return null; // Ou outra ação apropriada, como lançar um erro.
  }

  async function buscarListaTags() {
    try {
      let querys = `?cliente_id=${user.clienteId}`
      const response = await v2_actionListaTagsChats(querys);
      setListaTags(response.data.data)
    } catch (error) {

    }
  }


  async function buscarListaChats(querys, action, isPesquisado) {
    if (!clienteIdPadrao) return;
    setLoadingListaChats(true);
    if (action === 'pesquisar' && !filterPesquisa) {
      alert("Campo de pesquisa está vazio!");
      return;
    }

    try {
      // Adicionar filtros na query apenas quando não estiver pesquisando
      let filtersQuery = querys;

      if (!isPesquisado) {
        if (valorEscolhidoUsuario) {
          filtersQuery += `&filterUser=${valorEscolhidoUsuario}`;
        }

        if (valorEscolhidoSetor) {
          filtersQuery += `&filterDepartament=${valorEscolhidoSetor}`;
        }

        if (valorEscolhidoTag) {
          filtersQuery += `&filterTag=${valorEscolhidoTag}`;
        }

        if (valorEscolhidoSentimento) {
          filtersQuery += `&filterSentiment=${valorEscolhidoSentimento}`;
        }
      }

      // Adicionar parâmetros de paginação
      const paginationParams = `&page=${page + 1}&limit=${rowsPerPage}`;
      const fullQuery = filtersQuery + paginationParams;

      const response = await v2_actionListaChatsSupervisao(fullQuery);

      // Debug: verificar estrutura da resposta da API
      console.log('API Response:', response.data);
      console.log('Pagination:', response.data.pagination);

      // Capturar o total de registros do objeto pagination da API
      const total = response.data.pagination?.totalItems || response.data.data.length;
      setTotalRegistros(total);

      if (isPesquisado) {
        setListaChatsPesquisa(response.data.data);
        setLoadingListaChats(false);
      } else {
        setListaChatsFiltro(response.data.data);
        setLoadingListaChats(false);
      }


    } catch (error) {
      setLoadingListaChats(false);
      console.log(error)
    }

  }

  const onLoad = async () => {
    await Promise.all([
      dispatch(getListaUsuariosTransferencia(user.clienteId)),
      dispatch(getListaSetoresTransferencia(user.clienteId)),
      buscarListaClientesCanais(),
      buscarListaTags()
    ]);
    // Recarregar a lista de chats
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
    buscarListaChats(querys, "filtrar", false);
  }


  useEffect(() => {
    onLoad()
  }, [location, periodo]);

  useEffect(() => {
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
    buscarListaChats(querys, "filtrar", false)
  }, [clienteIdPadrao]);

  // Recarregar dados quando página ou linhas por página mudarem
  useEffect(() => {
    if (clienteIdPadrao) {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false);
    }
  }, [page, rowsPerPage]);

  // Recarregar dados quando os filtros mudarem
  useEffect(() => {
    if (clienteIdPadrao && !isPesquisado) {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false);
    }
  }, [valorEscolhidoUsuario, valorEscolhidoSetor, valorEscolhidoTag, valorEscolhidoSentimento, isPesquisado]);


  const handleFilterName = (filterName) => {
    setFilterName(filterName);
    // getListaPedidosVendaFacil()
    setPage(0);
  };

  const handleChangeClienteIdPadrao = (value) => {
    console.log('value', value)
    setClienteIdPadrao(value)
    if (filterPesquisa.length > 0) {
      onPesquisarCanal(value)
    } else {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${value}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false)
    }

  }

  const handlePesquisa = (e) => {
    setFilterPesquisa(e.target.value);
  };



  const onPesquisar = async () => {
    setIsPesquisado(true);
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=null&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=pesquisar&search=${filterPesquisa}`;
    await buscarListaChats(querys, "pesquisar", true)
  }

  const onPesquisarCanal = async (clienteId) => {
    setIsPesquisado(true);
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=null&cliente_id=${clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=pesquisar&search=${filterPesquisa}`;
    await buscarListaChats(querys, "pesquisar", true)
  }


  const onFiltrar = async (value, action) => {
    setIsPesquisado(false);
    setPeriodo(value)
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${value}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=${action}`;
    await buscarListaChats(querys, "filtrar", false);
    setFilterPesquisa('')
  }


  async function handleOpenDetails(card) {
    setLoadingVerDetalhes(true);
    // Limpar informações do chat anterior antes de carregar novo
    dispatch(setLimparChatInfo());
    setOpenChatDetalhes(true);

    const res = await v2_actionBuscarChatById(card._id, null, user.id)
    setChat(res.data);
    dispatch(setChatInfo(res.data));
    // Aguardar um pouco para garantir que o estado foi limpo antes de carregar mensagens
    await new Promise(resolve => setTimeout(resolve, 100));
    dispatch(getMensagensWhatsappDb(res.data.sessao, res.data.numeroCliente));
    setLoadingVerDetalhes(false);
    console.log('handleOpenDetails', card);
  }

  const dataFiltered = applySortFilter({
    tableData,
    filterStatus
  });



  const handleGerarExcelChats = async () => {
    try {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      let querys = `?periodo=${periodo}&${valorEscolhidoUsuario ? `usuario_id=${user.id}` : ''}&cliente_id=${clienteIdPadrao}&inicio=${inicio2}&final=${final2}${valorEscolhidoTag ? `&filterTag=${valorEscolhidoTag}` : ''}${valorEscolhidoUsuario ? `&filterUser=${valorEscolhidoUsuario}` : ''}${valorEscolhidoSetor ? `&filterDepartament=${valorEscolhidoSetor}` : ''}${valorEscolhidoSentimento ? `&filterSentiment=${valorEscolhidoSentimento}` : ''}`;
      const response = await v2_actionGerarExcelRelatorioChats(querys);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `lais-chats-supervisao.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error)
    }
  }


  const handleGerarExcelChatsPrimeiroContato = async () => {
    try {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      let querys = `?periodo=${periodo}&${valorEscolhidoUsuario ? `usuario_id=${user.id}` : ''}&cliente_id=${clienteIdPadrao}&inicio=${inicio2}&final=${final2}${valorEscolhidoTag ? `&filterTag=${valorEscolhidoTag}` : ''}${valorEscolhidoUsuario ? `&filterUser=${valorEscolhidoUsuario}` : ''}${valorEscolhidoSetor ? `&filterDepartament=${valorEscolhidoSetor}` : ''}${valorEscolhidoSentimento ? `&filterSentiment=${valorEscolhidoSentimento}` : ''}`;
      const response = await v2_actionGerarExcelRelatorioChatsPrimeiroContato(querys);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `lais-chats.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error)
    }
  }

  const denseHeight = dense ? 56 : 76;

  const isNotFound =
    (!dataFiltered.length && !!filterName) ||
    (!dataFiltered.length && !!filterStatus)

  return (

    <div className="h-full flex flex-col">
      {viewMode === 'table' && chat && (
        <DrawerChatWhatsapp
          chat={chat}
          open={openChatdetalhes}
          onClose={() => {
            setChat(null)
            setOpenChatDetalhes(false)
          }}
          listaFunil={listaFunil}
          source={'chat.supervisionar'}
        />
      )}


      <PageContainerHeader
        titleSection={
          <div className="flex flex-wrap items-center gap-4 flex-1">
            {/* Identificação */}
            <div className="flex items-center gap-2 min-w-fit">
              <div className="p-2 bg-[#7C3AED]/10 rounded-lg">
                <Iconify icon="mdi:monitor-dashboard" className="text-[#7C3AED]" width={20} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Supervisão</h3>
              </div>
            </div>

            <div className="h-8 w-px bg-gray-200/60 hidden xl:block mx-2" />

            {/* Filtros */}
            <div className="flex flex-wrap items-end gap-2 flex-1">
              <div className="w-[200px]">
                <span className='text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1 block pl-1'>Período</span>
                <MenuDatas2
                  anchorEl={anchorEl}
                  open={openMenuDatas}
                  onClose={() => setAnchorEl(false)}
                  inicial={inicio}
                  final={final}
                  content={validaLabelMenuDatas(periodo, inicio, final)}
                  customButton={
                    <Button
                      variant="outline"
                      className="w-full h-9 justify-between text-xs font-normal border-dashed border-gray-300 bg-transparent hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 text-gray-700"
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      <span className="truncate">{validaLabelMenuDatas(periodo, inicio, final)}</span>
                      <Iconify icon="mdi:calendar" className="ml-2 h-3.5 w-3.5 opacity-50" />
                    </Button>
                  }
                  changeInicial={newValue => setInicio(newValue)}
                  changeFinal={newValue => { setFinal(newValue) }}
                  onSelect={value => {
                    setPeriodo(value);
                    setAnchorEl(null);
                    onFiltrar(value, 'filtrar')
                  }}
                  onPesquisar={() => onFiltrar('null')}
                />
              </div>

              {isMultisession && (
                <div className="w-[200px]">
                  <span className='text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1 block pl-1'>Canal</span>
                  <Select
                    value={clienteIdPadrao || "all"}
                    onValueChange={e => {
                      let value = e === "all" ? null : e;
                      handleChangeClienteIdPadrao(value);
                    }}
                  >
                    <SelectTrigger className="h-9 text-xs border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                      <SelectValue placeholder="Todos" />
                    </SelectTrigger>
                    <SelectContent>
                      {listaClientesCanais.map((item) => (
                        <SelectItem key={item.cliente_id} value={item.cliente_id}>
                          {item.nome || "undefined"}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              {/* Botão Mais Filtros */}
              <div className="flex items-end">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button variant="outline" className="h-9 px-3 border-dashed border-gray-300 text-xs text-gray-600 hover:border-violet-500 hover:text-violet-600 hover:bg-violet-50 bg-transparent">
                      <Iconify icon="mdi:filter-plus" className="mr-2 h-4 w-4" />
                      Mais filtros
                      {(!!valorEscolhidoUsuario || !!valorEscolhidoSetor || !!valorEscolhidoTag || !!valorEscolhidoSentimento) && (
                        <span className="ml-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-violet-100 text-[10px] font-medium text-violet-800">
                          {(!!valorEscolhidoUsuario ? 1 : 0) + (!!valorEscolhidoSetor ? 1 : 0) + (!!valorEscolhidoTag ? 1 : 0) + (!!valorEscolhidoSentimento ? 1 : 0)}
                        </span>
                      )}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-80 p-4" align="start">
                    <div className="space-y-4">
                      <h4 className="font-medium text-sm text-gray-900 border-b border-gray-200 pb-2">Filtros Adicionais</h4>

                      <div className="space-y-3">
                        {/* Filtro Usuário */}
                        <div>
                          <label className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block'>Usuário</label>
                          <Select
                            value={valorEscolhidoUsuario || "all"}
                            onValueChange={e => {
                              let value = e === "all" ? null : e;
                              setValorEscolhidoUsuario(value);
                              setPage(0);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                              <SelectValue placeholder="Todos" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">Todos</SelectItem>
                              {listaUsuariosTransferencia.map((item) => (
                                <SelectItem key={item._id} value={item._id}>
                                  {item.firstName}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        {/* Filtro Setor */}
                        <div>
                          <label className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block'>Setor</label>
                          <Select
                            value={valorEscolhidoSetor || "all"}
                            onValueChange={e => {
                              let value = e === "all" ? null : e;
                              setValorEscolhidoSetor(value);
                              setPage(0);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                              <SelectValue placeholder="Todos" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">Todos</SelectItem>
                              {listaSetoresTransferencia.map((item) => (
                                <SelectItem key={item._id} value={item._id}>
                                  {item.nome_setor}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        {/* Filtro Tag */}
                        <div>
                          <label className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block'>Tag</label>
                          <Select
                            value={valorEscolhidoTag || "all"}
                            onValueChange={e => {
                              let value = e === "all" ? null : e;
                              setValorEscolhidoTag(value);
                              setPage(0);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                              <SelectValue placeholder="Todos" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">Todos</SelectItem>
                              {listaTags.map((item) => (
                                <SelectItem key={item._id} value={item._id}>
                                  {item.nome}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        {/* Filtro Sentimento */}
                        <div>
                          <label className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block'>Sentimento</label>
                          <Select
                            value={valorEscolhidoSentimento || "all"}
                            onValueChange={e => {
                              let value = e === "all" ? null : e;
                              setValorEscolhidoSentimento(value);
                              setPage(0);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                              <SelectValue placeholder="Todos" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">Todos</SelectItem>
                              {[
                                { value: "1", label: '1' },
                                { value: "2", label: '2' },
                                { value: "3", label: '3' },
                                { value: "4", label: '4' },
                                { value: "5", label: '5' },
                              ].map((item) => (
                                <SelectItem key={item.value} value={item.value}>
                                  {item.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            </div>
          </div>
        }
        middleSection={
          <div className="relative group w-full md:w-auto">
            <Input
              placeholder="Pesquisar..."
              value={filterPesquisa}
              className="w-full md:w-[200px] pl-3 pr-16 h-9 bg-gray-50 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all text-sm rounded-lg"
              onChange={e => {
                if (e.target.value.length === 0) {
                  setIsPesquisado(false);
                }
                setFilterPesquisa(e.target.value)
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' && filterPesquisa.length > 0) {
                  onPesquisar();
                }
              }}
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 gap-1">
              {isPesquisado && filterPesquisa && (
                <button
                  onClick={() => {
                    setIsPesquisado(false);
                    setFilterPesquisa('');
                  }}
                  className="flex items-center cursor-pointer text-gray-400 hover:text-red-500"
                >
                  <Iconify icon="mdi:close-circle" width={16} />
                </button>
              )}
              <button
                onClick={() => {
                  if (filterPesquisa.length > 0) {
                    onPesquisar();
                  }
                }}
                className="flex items-center cursor-pointer text-gray-400 hover:text-[#7C3AED] transition-colors"
              >
                <Iconify icon="eva:search-outline" width={18} />
              </button>
            </div>
          </div>
        }
        rightSection={
          <div className="flex items-center gap-2 w-full md:w-auto justify-end">
            {/* View toggle */}
            <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
              <button
                onClick={() => setViewMode('table')}
                className={`h-8 w-8 flex items-center justify-center rounded-md transition-all ${viewMode === 'table' ? 'bg-white shadow-sm text-[#7C3AED]' : 'text-gray-500 hover:text-gray-700'}`}
                title="Visualização em tabela"
              >
                <Iconify icon="mdi:table" width={18} />
              </button>
              <button
                onClick={() => setViewMode('split')}
                className={`h-8 w-8 flex items-center justify-center rounded-md transition-all ${viewMode === 'split' ? 'bg-white shadow-sm text-[#7C3AED]' : 'text-gray-500 hover:text-gray-700'}`}
                title="Visualização em painel"
              >
                <Iconify icon="mdi:view-split-vertical" width={18} />
              </button>
            </div>

            <Button
              className="h-9 w-9 p-0 rounded-lg border-dashed border-gray-300 text-gray-600 hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-[#7C3AED]/5"
              variant="outline"
              onClick={onLoad}
              title="Recarregar"
            >
              <Iconify icon="mdi:reload" width={18} />
            </Button>

            <SupervisaoExport
              onExportListChats={() => handleGerarExcelChats()}
              onExportListChatsPrimeiroContato={() => handleGerarExcelChatsPrimeiroContato()}
            />
          </div>
        }
      />

      {viewMode === 'table' ? (
        /* ========== TABLE VIEW ========== */
        <div className='w-[98%] mx-auto flex flex-col flex-1 min-h-0'>
          {loadingListaChats ? (
            <Container maxWidth={'xl'}>
              <Card sx={{ display: 'flex', flexDirection: 'column', height: '90vh' }}>
                <SkeletonSupervisionList />
              </Card>
            </Container>
          ) : (
            <Card className="rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col flex-1 min-h-0">
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  allowScrollButtonsMobile
                  variant="scrollable"
                  scrollButtons="auto"
                  value={filterStatus}
                  onChange={onChangeFilterStatus}
                  sx={{
                    px: 2,
                    '& .MuiTab-root': {
                      minHeight: 48,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Mui-selected': { color: '#7C3AED' },
                    },
                    '& .MuiTabs-indicator': { backgroundColor: '#7C3AED' },
                  }}
                >
                  {STATUS_OPTIONS.map((tab) => (
                    <Tab disableRipple key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                </Tabs>
              </Box>

              <div className='p-3 flex-1 min-h-0 flex flex-col'>
                <Scrollbar sx={{ flex: 1, minHeight: 0 }}>
                  <Table>
                    <TableHeader className="bg-gray-50/80 p-2">
                      {TABLE_HEAD.map((item, index) => (
                        <TableHead key={index}>{item.label}</TableHead>
                      ))}
                    </TableHeader>
                    <TableBody>
                      {dataFiltered.map((row) => (
                        <SupervisaoRow
                          key={row._id}
                          row={row}
                          chat={chat}
                          loading={loadingVerDetalhes}
                          selected={selected.includes(row.id)}
                          onSelectRow={() => onSelectRow(row.id)}
                          onViewRow={() => handleOpenDetails(row)}
                        />
                      ))}
                      <TableEmptyRows height={denseHeight} emptyRows={emptyRows(page, rowsPerPage, totalRegistros)} />
                      <TableNoData isNotFound={isNotFound} />
                    </TableBody>
                  </Table>
                </Scrollbar>
                <Box sx={{ position: 'relative' }}>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count !== -1 ? count : `mais de ${to}`}`}
                    count={totalRegistros}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={onChangePage}
                    onRowsPerPageChange={onChangeRowsPerPage}
                    sx={{
                      '.MuiTablePagination-toolbar': { color: 'inherit' },
                      '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': { color: 'inherit' },
                      '.MuiTablePagination-select': { color: 'inherit' },
                      '.MuiTablePagination-actions': { color: 'inherit' },
                    }}
                  />
                </Box>
              </div>
            </Card>
          )}
        </div>
      ) : (
        /* ========== SPLIT PANEL VIEW ========== */
        <div className="flex gap-2 px-3 overflow-hidden flex-1 min-h-0">

          {/* Status Sidebar */}
          <div className="w-[72px] min-w-[72px] flex-shrink-0 flex flex-col bg-white border border-gray-100 rounded-2xl overflow-hidden">
            <div className="flex flex-col items-center py-2 gap-0.5 flex-1">
              {STATUS_SIDEBAR_OPTIONS.map((item) => {
                const isActive = filterStatus === item.value;
                const count = item.value === null
                  ? tableData.length
                  : tableData.filter(c => c.statusRoom === item.value).length;

                return (
                  <button
                    key={item.label}
                    onClick={() => onChangeFilterStatus(null, item.value)}
                    className={cn(
                      "group relative w-[60px] flex flex-col items-center gap-0.5 py-2.5 rounded-xl transition-all cursor-pointer border-2",
                      isActive
                        ? `${item.activeBg} ${item.activeBorder} shadow-sm`
                        : "border-transparent hover:bg-gray-50/80"
                    )}
                    title={item.label}
                  >
                    {/* Icon */}
                    <div className={cn(
                      "w-8 h-8 rounded-lg flex items-center justify-center transition-all",
                      isActive ? item.activeIcon : "text-gray-400 group-hover:text-gray-600"
                    )}>
                      <Iconify icon={item.icon} width={20} />
                    </div>

                    {/* Label */}
                    <span className={cn(
                      "text-[9px] font-semibold leading-tight text-center transition-colors",
                      isActive ? item.activeLabel : "text-gray-400 group-hover:text-gray-600"
                    )}>
                      {item.label}
                    </span>

                    {/* Count badge */}
                    {count > 0 && (
                      <span className={cn(
                        "absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center leading-none",
                        isActive
                          ? `${item.dot} text-white`
                          : "bg-gray-200 text-gray-600"
                      )}>
                        {count > 99 ? '99+' : count}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Bottom indicator */}
            <div className="border-t border-gray-100 py-2 flex justify-center">
              <div className="flex flex-col items-center gap-0.5">
                <span className="text-sm font-bold text-gray-900">{totalRegistros}</span>
                <span className="text-[8px] text-gray-400 uppercase font-semibold tracking-wider">Total</span>
              </div>
            </div>
          </div>

          {/* Chat List */}
          <Card className="w-[380px] min-w-[340px] flex-shrink-0 flex flex-col p-0 overflow-hidden">
            {/* Chat List */}
            <div className="flex-1 overflow-y-auto">
              {loadingListaChats ? (
                <div className="p-4 space-y-3">
                  {[...Array(8)].map((_, i) => (
                    <div key={i} className="animate-pulse flex items-start gap-3">
                      <div className="w-9 h-9 rounded-full bg-gray-200" />
                      <div className="flex-1 space-y-2">
                        <div className="h-3 bg-gray-200 rounded w-3/4" />
                        <div className="h-2 bg-gray-200 rounded w-1/2" />
                        <div className="h-2 bg-gray-200 rounded w-2/3" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : dataFiltered.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                  <Iconify icon="mdi:chat-outline" width={40} className="text-gray-300 mb-3" />
                  <p className="text-sm font-medium text-gray-500">Nenhum chat encontrado</p>
                  <p className="text-xs text-gray-400 mt-1">Ajuste os filtros para ver resultados</p>
                </div>
              ) : (
                dataFiltered.map((row) => (
                  <SupervisaoChatItem
                    key={row._id}
                    row={row}
                    isSelected={chat?._id === row._id}
                    onClick={() => handleOpenDetails(row)}
                  />
                ))
              )}
            </div>

            {/* Carregar mais - fixo no bottom */}
            {!loadingListaChats && dataFiltered.length > 0 && dataFiltered.length < totalRegistros && (
              <div className="border-t border-gray-100 flex-shrink-0">
                <button
                  onClick={() => {
                    onChangeRowsPerPage({ target: { value: rowsPerPage + 25 } });
                  }}
                  disabled={loadingListaChats}
                  className="w-full py-2.5 text-xs font-medium text-[#7C3AED] hover:bg-violet-50 transition-colors cursor-pointer disabled:opacity-50"
                >
                  {loadingListaChats ? 'Carregando...' : `Carregar mais (${dataFiltered.length} de ${totalRegistros})`}
                </button>
              </div>
            )}
          </Card>

          {/* Main Content - Chat Details */}
          <Card className="flex-1 flex flex-col min-w-0 overflow-hidden">
            {loadingVerDetalhes ? (
              <div className="flex items-center justify-center h-full">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-8 h-8 border-2 border-[#7C3AED] border-t-transparent rounded-full animate-spin" />
                  <p className="text-sm text-gray-500">Carregando conversa...</p>
                </div>
              </div>
            ) : chatInfo ? (
              <ChatWindow
                config={null}
                chatInfo={chatInfo}
                source="chat.supervisionar"
                onCloseModal={() => {
                  setChat(null);
                  dispatch(setLimparChatInfo());
                }}
                hideSidebar={false}
              />
            ) : (
              <div className="flex flex-col items-center justify-center h-full p-12 text-center">
                <div className="w-16 h-16 bg-violet-50 rounded-2xl flex items-center justify-center mb-5">
                  <Iconify icon="mdi:monitor-dashboard" width={28} className="text-[#7C3AED]" />
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-1.5">Selecione um chat</h3>
                <p className="text-sm text-gray-500 max-w-sm">
                  Escolha um chat na lista ao lado para visualizar a conversa, detalhes e informações do atendimento.
                </p>
              </div>
            )}
          </Card>
        </div>
      )}
    </div>
  );
}

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  filterStatus
}) {

  if (filterStatus !== null) {
    tableData = tableData.filter((item) => item.statusRoom === filterStatus)
  }

  return tableData;
}

